import React, { useEffect, useMemo, useRef, useState } from 'react';

const SearchableDealerSelect = ({
  dealers = [], value, onSelect, hasError, disabled,
  placeholder = 'Search dealer', getLabel = item => item.dealerName,
  getKey = item => item.dealerId || item.id || getLabel(item)
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const filteredDealers = useMemo(() => {
    const query = String(value || '').trim().toLowerCase();
    return dealers.filter(item => !query || String(getLabel(item) || '').toLowerCase().includes(query));
  }, [dealers, value, getLabel]);

  useEffect(() => {
    const close = event => { if (!rootRef.current?.contains(event.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  return <div className={`searchable-dealer ${open ? 'is-open' : ''}`} ref={rootRef}>
    <div className={`searchable-dealer-field ${hasError ? 'error' : ''}`}>
      <input type="search" value={value} disabled={disabled} autoComplete="off" placeholder={placeholder}
        aria-expanded={open} onFocus={() => setOpen(true)} onChange={event => { onSelect(event.target.value); setOpen(true); }} />
      <button type="button" disabled={disabled} className="searchable-dealer-toggle"
        aria-label={open ? 'Close dealer list' : 'Open dealer list'} onClick={() => setOpen(current => !current)} />
    </div>
    {open && !disabled && <div className="searchable-dealer-options" role="listbox">
      {filteredDealers.length ? filteredDealers.map(item => <button type="button" role="option"
        aria-selected={getLabel(item) === value} className={getLabel(item) === value ? 'selected' : ''}
        key={getKey(item)} onClick={() => { onSelect(getLabel(item)); setOpen(false); }}>
        {getLabel(item)}
      </button>) : <div className="searchable-dealer-empty">No dealers found</div>}
    </div>}
  </div>;
};

export default SearchableDealerSelect;
